import React from 'react'
import { Layout } from 'react-admin'
import MyAppBar from './AppBar';
import Menu from '../Menu';
import { SupportChat } from '../../components/SupportChat';
import GiftMigrationNotice from '../../components/GiftMigrationNotice';
import { usePageTracking } from '../../lib/analytics';

const MyLayout = ({ children }: { children: React.ReactNode }) => {
    usePageTracking();
    return (
        <>
            <Layout
                appBar={MyAppBar}
                menu={Menu}
            >
                {children}
            </Layout>
            <GiftMigrationNotice />
            <SupportChat />
        </>
    );
};

export default MyLayout;